import { Modal } from "react-bootstrap";
import API from "../../axios.jsx";

const SEC = { fontSize: 11, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#16342a", background: "#eef1e7", borderRadius: 6, padding: "5px 11px", margin: "16px 0 8px" };
const FILA = { display: "flex", justifyContent: "space-between", gap: 12, padding: "5px 0", borderBottom: "1px solid #f1f3f5", fontSize: 13 };
const LBL = { color: "#6c757d", flexShrink: 0 };
const VAL = { fontWeight: 600, textAlign: "right" };

function Dato({ label, valor }) {
  if (valor === undefined || valor === null || valor === "") return null;
  return (
    <div style={FILA}>
      <span style={LBL}>{label}</span>
      <span style={VAL}>{valor}</span>
    </div>
  );
}

const VACUNAS = [
  { clave: "bcg", nombre: "BCG" },
  { clave: "rotavirus2", nombre: "Rotavirus 2" },
  { clave: "neumococo2", nombre: "Neumococo 2" },
  { clave: "polio3", nombre: "Polio 3" },
  { clave: "pentavalente3", nombre: "Pentavalente 3" },
  { clave: "neumococo_refuerzo", nombre: "Neumococo refuerzo" },
  { clave: "triple_viral_1", nombre: "Triple viral 1ª dosis" },
  { clave: "fiebre_amarilla", nombre: "Fiebre Amarilla" },
  { clave: "triple_viral_refuerzo18", nombre: "Triple viral refuerzo 18 meses" },
  { clave: "hepatitis_a", nombre: "Hepatitis A" },
  { clave: "triple_viral_2a5", nombre: "Triple viral refuerzo 2-5 años" },
];

export default function VerMrcvModal({ show, onClose, registro }) {
  if (!registro) return null;
  const r = registro;
  const v = r.visita || {};

  return (
    <Modal show={show} onHide={onClose} centered scrollable size="lg">
      <Modal.Header closeButton style={{ background: "linear-gradient(135deg, #16342a, #2d6a4f)", color: "#fff" }}>
        <Modal.Title style={{ fontSize: "1rem" }}>📋 MRCV — {r.nombre_nino}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={SEC}>🧒 Identificación del niño/a</div>
        <Dato label="Nombre" valor={r.nombre_nino} />
        <Dato label="Documento" valor={r.documento_nino} />
        <Dato label="Fecha de nacimiento" valor={r.fecha_nacimiento?.split?.("T")?.[0] || r.fecha_nacimiento} />
        <Dato label="Fecha de encuesta" valor={r.fecha_encuesta?.split?.("T")?.[0] || r.fecha_encuesta} />
        <Dato label="Edad" valor={r.anios_cumplidos != null ? `${r.anios_cumplidos} años (${r.meses_cumplidos} meses)` : null} />
        <Dato label="Grupo de edad" valor={r.grupo_edad} />

        <div style={SEC}>👩 Madre / acudiente</div>
        <Dato label="Nombre" valor={r.nombre_madre} />
        <Dato label="Documento" valor={r.documento_madre} />
        <Dato label="Teléfono" valor={r.telefono} />

        <div style={SEC}>🏥 Afiliación y enfoque</div>
        <Dato label="Régimen" valor={r.regimen} />
        <Dato label="Aseguradora" valor={r.aseguradora} />
        <Dato label="Etnia" valor={r.etnia} />
        <Dato label="Desplazamiento" valor={r.condicion_desplazamiento} />

        <div style={SEC}>📍 Vivienda</div>
        <Dato label="Código vivienda" valor={v.codigo_vivienda} />
        <Dato label="Territorio" valor={v.territorio} />
        <Dato label="Comunidad" valor={v.comunidad} />
        <Dato label="Entrevistador" valor={v.entrevistador} />
        {v.foto_url && (
          <a href={`${API.defaults.baseURL}${v.foto_url}`} target="_blank" rel="noreferrer">
            <img src={`${API.defaults.baseURL}${v.foto_url}`} alt="Vivienda" style={{ width: "100%", maxHeight: 200, objectFit: "cover", borderRadius: 8, marginTop: 8 }} />
          </a>
        )}

        <div style={SEC}>🪪 Carné</div>
        <Dato label="¿Tiene carné?" valor={r.tiene_carnet} />
        {r.tiene_carnet === "NO" && <Dato label="Motivo" valor={r.motivo_no_carnet} />}

        {(r.carnet_foto_a_url || r.carnet_foto_b_url) && (
          <div className="d-flex gap-2 mt-2">
            {r.carnet_foto_a_url ? (
              <a href={`${API.defaults.baseURL}${r.carnet_foto_a_url}`} target="_blank" rel="noreferrer">
                <img src={`${API.defaults.baseURL}${r.carnet_foto_a_url}`} alt="Cara A" style={{ width: 110, height: 110, objectFit: "cover", borderRadius: 8, border: "1px solid #dee2e6" }} />
              </a>
            ) : (
              <div style={{ width: 110, height: 110, borderRadius: 8, background: "#eef1e7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#8a94a6" }}>Sin foto A</div>
            )}
            {r.carnet_foto_b_url ? (
              <a href={`${API.defaults.baseURL}${r.carnet_foto_b_url}`} target="_blank" rel="noreferrer">
                <img src={`${API.defaults.baseURL}${r.carnet_foto_b_url}`} alt="Cara B" style={{ width: 110, height: 110, objectFit: "cover", borderRadius: 8, border: "1px solid #dee2e6" }} />
              </a>
            ) : (
              <div style={{ width: 110, height: 110, borderRadius: 8, background: "#eef1e7", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "#8a94a6" }}>Sin foto B</div>
            )}
          </div>
        )}

        {r.tiene_carnet === "SI" && (
          <>
            <Dato label="¿Esquema completo?" valor={r.esquema_completo} />
            {r.esquema_completo === "No" && <Dato label="Motivo de no vacunación" valor={r.motivo_no_vacunacion} />}
            <div style={SEC}>💉 Esquema — fecha de aplicación y verificación PAIWEB</div>
            {VACUNAS.map(({ clave, nombre }) => {
              const fecha = r[`${clave}_fecha`];
              const verificado = r[`${clave}_verificado`];
              if (!fecha && !verificado) return null;
              return (
                <div key={clave} style={FILA}>
                  <span style={LBL}>{nombre}</span>
                  <span style={VAL}>
                    {fecha ? (fecha.split?.("T")?.[0] || fecha) : "—"}
                    {verificado && <span className={`badge ms-2 ${verificado === "SI" ? "bg-success" : "bg-secondary"}`}>{verificado}</span>}
                  </span>
                </div>
              );
            })}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}